import PivotGridColumnProps from './Columns'

let KendoPivotGridColumn = {
    name: 'kendo-pivot-column',
    render () {
        return null
    },
    mixins: [PivotGridColumnProps]
}

export default KendoPivotGridColumn


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotColumn/index.js